import React, { FC, useState, ChangeEvent, FormEvent } from 'react'
import { H2 } from 'components/base/typography/headings'
import { P, Strong } from 'components/base/typography/misc'
import { Ul, Li } from 'components/base/typography/lists'
import { StrongLabel } from 'components/base/forms/label'
import { Input } from 'components/base/forms/input'
import Button from 'components/base/buttons/buttons'
import { Flex } from 'rebass'
import { useRouter } from 'next/router'
import { RichTextBlock } from 'prismic-reactjs'
// @ts-ignore
import { RichText } from 'prismic-reactjs'
import styled from 'styled-components'
import { RichTextStyleWrapper } from 'components/base/typography/richTextStyleWrapper'

interface Props {
	title: RichTextBlock[]
	text: RichTextBlock[]
}

const TextWrapper = styled(RichTextStyleWrapper as any)`
	margin-bottom: 5rem;
`

const NotACustomer: FC<Props> = ({ title, text }) => {
	const router = useRouter()
	const [loading, setLoading] = useState(false)
	const [companySocialId, setCompanySocialId] = useState('')

	const handleSocialIdChange = (e: ChangeEvent<HTMLInputElement>) => setCompanySocialId(e.target.value)

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault()
		if (companySocialId.length === 0) return
		setLoading(true)
		router.push(`/nyr-vidskiptavinur?id=${companySocialId}`)
	}

	return (
		<div>
			<H2 mt="1rem" mb="3rem">
				{RichText.asText(title || [])}
			</H2>
			<TextWrapper>{RichText.render(text || [])}</TextWrapper>
			<form onSubmit={handleSubmit}>
				<StrongLabel htmlFor="company-social-id" mb="1.2rem">
					Kennitala fyrirtækis
				</StrongLabel>
				<Input
					id="company-social-id"
					name="company-social-id"
					aria-label="Kennitala fyrirtækis"
					value={companySocialId}
					placeholder="Sláðu inn kennitölu"
					onChange={handleSocialIdChange}
				/>
				<Flex justifyContent="flex-end" mt="2.2rem">
					<Button type="submit" primary isLoading={loading}>
						Næsta skref
					</Button>
				</Flex>
			</form>
		</div>
	)
}

export default NotACustomer
